import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const updateProcessingFee = async ({ processingFeeEnabled, margin, applyToFreeEsim, freeSimFee }) => {
  try {
    console.log('Updating processingFee:', processingFeeEnabled, margin, applyToFreeEsim);
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const URL = routes.PROCESSING_FEE;
    const response = await axios.put(URL, {processingFeeEnabled, margin, applyToFreeEsim, freeSimFee}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export default updateProcessingFee;